
//const
const APPLY_TSDATABASE_SPACE_UPDATE_DATA = "applyTsdatabaseSpace/APPLY_TSDATABASE_SPACE_UPDATE_DATA"

//reducer
export const applyTsdatabaseSpace = (state = {
  months:1,
  tsDatabaseSize:"",
},action) => {
  switch (action.type) {
    case APPLY_TSDATABASE_SPACE_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      }
    default:
      return state
  }
}
//actions
export const updateData = (data) => {
  return {
    type: APPLY_TSDATABASE_SPACE_UPDATE_DATA,
    data: data
  }
}
